<template>
	<div class="ability-detail" _overflow="hidden">
		<div class="ability-detail-header" @click="routeBack">
			<i class="el-icon-arrow-left" style="margin-right: 5px; font-weight: 1000;"></i>返回
		</div>
		<div v-if="visible" _overflow="hidden" ref="irfameBox" :style="{ height: iframeMinHeight }" class="w-relative">
		</div>
	</div>
</template>
<script>
import { RenderElement } from 'sing-along-sync'
export default {
	data() {
		return {
			RESOURCE_URL: null,
			id: null,
			iframeMinHeight: '',
			iframeMarginBottom: '',
			visible: false,
			renderElement: null,
			iframeSize: { width: 1920, height: 0, scale: 1 }
		}
	},
	created() {
		const { id } = this.$route.params
		this.id = id
		this.RESOURCE_URL =
			window.location.hostname !== 'localhost'
				? window.web_config.server_url + window.web_config.music_score_display_path
				: window.RESOURCE_URL

		this.visible = true
	},
	async mounted() {
		this.iframeMinHeight = window.innerHeight - 150 + 'px'
		document.body.style['overflow-y'] = 'hidden'
		try {
			const musciData = await this.$api.musical_sample.querySingAlong(this.id)
			const renderElement = this.renderElement = new RenderElement({
        scale: 1,
				data: musciData
			})
            this.$refs.irfameBox.appendChild(renderElement)
			this.getIframeSize()
		} catch (err) {
			console.log(err, '=====')
			this.$message.error('引用的曲谱已被删除')
		}
	},
	beforeDestroy() {
		this.renderElement.stop()
		this.renderElement = null
	},
	destroyed() {
		document.body.style['overflow-y'] = 'auto'
	},
	methods: {
		routeBack() {
			this.$router.push({
				name: 'singAlongManagement'
			})
		},
		// 计算根据缩放比和实际宽高
		getIframeSize() {
			this.$nextTick(() => {
				const size = { width: 1920, height: 0, scale: 1 }
				const irfameBox = this.$refs.irfameBox
				if (irfameBox) {
					const clientHeight = irfameBox.clientHeight
					const clientWidth = irfameBox.clientWidth
					size.scale = clientWidth / size.width
					size.height = clientHeight / size.scale
				}
				Object.assign(this.iframeSize, size)
			})
		},
	},
}
</script>
<style scoped lang="scss">
.ability-detail {
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	overflow: hidden;
	height: 100%;
	.ability-detail-header {
		display: flex;
		align-items: center;
		font-size: 16px;
		padding: 15px 15px 15px 25px;
		cursor: pointer;
	}
	.ability-detail-header:hover {
		color: #ff5e2a;
	}
}
</style>
